import React, { Component } from 'react';
import { IdentificacionContentPanel } from './IdentificacionContentPanel';
import FetchService from '../../services/FetchService.js';

export class IdentificacionForm extends Component {
    constructor(props) {
        super(props); 
    }
    componentDidMount() {
        var url = 'api/Sesion/CargarPermisos';
        FetchService.send(url, 'GET', null, this.cargarPermisos.bind(this), this.cargarPermisosError.bind(this));
    }
    cargarPermisos(permisos) {
        if (!permisos.AllowIdentification) {
            this.props.history.push('/home');
        }  
    }
    cargarPermisosError(err) {
        this.props.history.push('/home');
    }
    render() {
        return (
            <div> 
                <div>
                    <IdentificacionContentPanel />
                </div> 
            </div >
        );
    }
}
